export const USER_TABLE_COLUMNS = ["first_name", "last_name", "email", "mobile", "role","is_approved", "actions"];
export const USER_PAGE_TITLE = "User Management";
export const USER_ROLE_OPTIONS = {
    ADMIN:"ADMIN",
    EMPLOYEE:"EMPLOYEE",
};
export const USER_COLUMN_LABELS = {
    first_name: "First Name",
    last_name: "Last Name",
    email: "Email",
    mobile: "Mobile",
    role: "Role",
    is_approved: "Status",
    actions: "Actions",
    
};

export const ROLE_FILEDS = [
    {label: "Admin", value: "ADMIN"},
    {label: "Employee", value: "EMPLOYEE"},
]

export const MESSAGES = {
    NO_USER_DATA: "No user data available",
    USER_FETCH_ERROR: "Failed to fetch user data",
    USER_FETCH_SUCCESS: "Users data fetched successfully",
    USER_UPDATE_SUCCESS: "User updated successfully",
    USER_UPDATE_ERROR: "Failed to update user",
    DELETE_SUCCESSFUL: "User deleted Successfully",
    DELETE_UNSUCCESSFUL: "User not deleted",
    ERROR_OCCURRED: "Some Error Occurred"
}